var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.fetched)?_c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":"switch"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }